import React, { useState, useEffect } from "react";
import { DisabilityDocumentDisplayCard } from "./components/DisabilityDocumentDisplayCard";
import "./styles/disbilityDashboardStyle.css";
import { DisablilityListingCard } from "./components/DisablilityListingCard";
import { DisabilityLiabilityCard } from "./components/DisabilityLiabilityCard";
import { DisabilityLegalDocumentCard } from "./components/DisabilityLegalDocumentCard";
import { BudgetExpanse } from "../../../../newComponents/MainDashboard/BudgetExpanse";
import { DisabilityInsuranceCard } from "./components/DisabilityInsuranceCard";
import { MODULE_API } from "../../../../apis";
import empolymentInfoIcon from "../../../../assets/images/currency3.png";
import medicalInfoIcon from "../../../../assets/images/healthy.png";
import primaryInfoIcon from "../../../../assets/images/doctor.png";
import homeInfoIcon from "../../../../assets/images/remodel2.png";
import medicalHistoryIcon from "../../../../assets/images/hospital.png";
import assetInfoIcon from "../../../../assets/images/n.png";
import contactInfoIcon from "../../../../assets/images/people.png";
import equipmentInfoIcon from "../../../../assets/images/room_and_board.png";
import budgetInfoIcon from "../../../../assets/images/savings.png";
import legalInfoIcon from "../../../../assets/images/trust.png";
import dailyInfoIcon from "../../../../assets/images/retirement.png";
import insuranceInfoIcon from "../../../../assets/images/insurance.png";
import treatmentInfoIcon from "../../../../assets/images/charity.png";
import moment from "moment";
import FETCH from "../../../../utils/fetch";
import DASHBOARD_API from "../../../../apis/dashboard.api";
import ModalVideo from "../../../../newComponents/ModuleVideos/ModalVideo";

export const DisabilityDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [budgets, setBudgets] = useState([]);
  const [insuranceData, setInsuranceData] = useState([]);
  const [monetaryValue, setMonetaryValue] = useState(0);
  const [totalLoan, setTotalLoan] = useState(0);
  const [tableData, setTableData] = useState({});
  const [fieldsData, setFieldsData] = useState({});

  const [fileUpload, setFileUpload] = useState({
    createdAt: "2025-03-28T10:41:53.000Z",
    "Document Upload":
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/81a1f8e1-4c40-430e-b629-6ef833763e65.xlsx",
    "Uploaded File Name": "Disability Updates (2).xlsx",
  });
  const cardMessages = {
    "Employment Information": {
      name: "Employment Information",
      Icon: empolymentInfoIcon,
      Purpose:
        "Documents current work status, income sources, and potential workplace accommodations. Critical for understanding financial impact, disability benefits, and potential career modifications.",
      tooltip: "Disability_Employment_Information"
    },
    "Insurance Coverage": {
      name: "Insurance Coverage",
      Icon: insuranceInfoIcon,
      Purpose:
        "Documents current work status, income sources, and potential workplace accommodations. Critical for understanding financial impact, disability benefits, and potential career modifications.",
      tooltip: "Disability_Insurance_Coverage"
    },
    "Primary Caregivers": {
      name: "Primary Caregivers",
      Icon: primaryInfoIcon,
      Purpose:
        "Documents current work status, income sources, and potential workplace accommodations. Critical for understanding financial impact, disability benefits, and potential career modifications.",
      tooltip: "Disability_Primary_Caregivers"
    },
    "Professional Contacts": {
      name: "Professional Contacts",
      Icon: contactInfoIcon,
      Purpose:
        "Documents current work status, income sources, and potential workplace accommodations. Critical for understanding financial impact, disability benefits, and potential career modifications.",
      tooltip: "Disability_Professional_Contacts"
    },
    "Medical Information": {
      name: "Medical Information",
      Icon: medicalInfoIcon,
      Purpose:
        "Provides comprehensive health background necessary for treatment planning, insurance claims, and determining disability support needs. Helps create a holistic view of medical challenges and required interventions.",
      tooltip: "Disability_Medical_Information"
    },
    "Medical History": {
      name: "Medical History",
      Icon: medicalHistoryIcon,
      Purpose:
        "Medical history is a comprehensive record of an individual's health journey, documenting past and current medical conditions, treatments, diagnoses, medications, surgeries, hospitalizations, allergies, and family medical background.",
      tooltip: "Disability_Medical_History"
    },
    "Legal Documents": {
      name: "Legal Documents",
      Icon: legalInfoIcon,
      Purpose:
        "Ensures legal preparedness by documenting critical decision-making authorities and wishes. Protects personal and financial interests during periods of potential incapacity.",
      tooltip: "Disability_Legal_Documents"
    },
    "Home Modifications": {
      name: "Home Modifications",
      Icon: homeInfoIcon,
      Purpose:
        "Documents required physical modifications and adaptive technologies to maintain independence, functionality, and quality of life.",
      tooltip: "Disability_Home_Modifications"
    },
    "Equipment Needs": {
      name: "Equipment Needs",
      Icon: equipmentInfoIcon,
      Purpose:
        "Helps anticipate and budget for essential assistive technologies, mobility aids, medical devices and adaptive tools that can improve quality of life, independence, accessibility, and daily functioning.",
      tooltip: "Disability_Equipment_Needs"
    },
    "Daily Living Preferences": {
      name: "Daily Living Preferences",
      Icon: dailyInfoIcon,
      Purpose:
        "Captures personal wishes for treatment, daily living, and overall care approach. Ensures individual dignity and personal choice are maintained.",
      tooltip: "Disability_Daily_Living_Preferences"
    },
    "Treatment Preferences": {
      name: "Treatment Preferences",
      Icon: treatmentInfoIcon,
      Purpose:
        "Allows individuals to communicate their medical care wishes, ensuring their values are respected, guiding healthcare providers on desired treatments, and preserving personal autonomy during medical challenges.",
      tooltip: "Disability_Treatment_Preferences"
    },
  };
  const getInsuranceList = async () => {
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: userRole === "Financial Advisor Client"
            ? `?module=Insurance Products V2&page=1&limit=50&clientId=${ID}`
            : `?module=Insurance Products V2&page=1&limit=50`,
        body: {},
      });
      setLoading(false);
      if (datares && datares.records) {
        setInsuranceData(datares.records);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getBudgets = async (startDate, endDate) => {
    try {
      setLoading(true);
      setBudgets([]);
      let data = await MODULE_API.getFilterBudgets(startDate, endDate);
      if (data && data.data) {
        setBudgets(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getMonetaryValueAssets = async () => {
    try {
      setLoading(true);
      setMonetaryValue(0);
      const moduleName = "Assets";
      let data = await DASHBOARD_API.fetchMonetaryValueofModule(moduleName);
      if (
        data &&
        data.data &&
        data.data[0] &&
        data.data[0].monetary &&
        data.data[0].monetary !== null
      ) {
        setMonetaryValue(data.data[0].monetary);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getLiabilitySum = async () => {
    try {
      setLoading(true);
      setTotalLoan(0);
      let data = await MODULE_API.fetchLiabilitySum("Liability");
      console.log(data);
      if (data && data.sum) {
        setTotalLoan(data.sum);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const moduleNames = [
    "Primary Caregiver",
    "Professional Contacts",
    "Upload Document",
    "Upload Document Medical Information",
    "Adaptive Technology",
    "Upload Document Medical history",
    "Upload Document Home Modifications",
    "Upload Document Daily Living Preference",
    "Upload Document Care Plan",
  ];
  const fetchAllModulesData = async () => {
    try {
      setLoading(true);
      const results = await Promise.all(
        moduleNames.map((name) => fetchData(name))
      );
      console.log("All module results:", results);
      const primaryCaresGiverMod = results.find(
        (item) => item.moduleName === "Primary Caregivers"
      );
      if (primaryCaresGiverMod) {
        const targetRecord = primaryCaresGiverMod.records.find(
          (record) =>
            record.subType === "Disability" ||
            "Professional Care Provider" in record
        );
        setFieldsData(targetRecord);
      } else {
        console.log("Medical History module not found");
      }

      const tableDataObj = results.reduce((acc, { moduleName, records }) => {
        acc[formatModuleKey(moduleName)] = records;
        return acc;
      }, {});

      setTableData(tableDataObj);
    } catch (error) {
      console.error("Error fetching all modules:", error);
    } finally {
      setLoading(false);
    }
  };
  console.log("tableData", tableData);
  const fetchData = async (moduleName) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      const records = res.records || [];
      setLoading(false);
      return { moduleName, records }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    } finally {
      setLoading(false);
    }
  };
  const formatModuleKey = (moduleName) => {
    return (
      moduleName &&
      moduleName
        .replace(/[^a-zA-Z ]/g, "") // Remove special chars
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
          index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "") + "Data"
    );
  };

  const getAll = async () => {
    const date = moment();
    const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
    const endDate = date.endOf("month").format("YYYY-MM-DD");
    await fetchAllModulesData();
    await getLiabilitySum();
    await getMonetaryValueAssets();
    await getBudgets(startDate, endDate);
    await getInsuranceList();
  };
  useEffect(() => {
    getAll();
  }, []);

  return (
    <div>
      <div className="MainDisabilityDashboard">
        <ModalVideo module="Disability" autoOpen={true} />
        <div className="mainUpperContainer">
          <DisabilityDocumentDisplayCard
            step={0}
            moduleData={cardMessages["Employment Information"]}
            fileUpload={fileUpload}
            documents={
              tableData &&
              tableData.uploadDocumentData &&
              tableData.uploadDocumentData
            }
            loading={loading}
          />
          <DisabilityDocumentDisplayCard
            step={1}
            moduleData={cardMessages["Medical Information"]}
            documents={
              tableData &&
              tableData.uploadDocumentMedicalInformationData &&
              tableData.uploadDocumentMedicalInformationData
            }
            fileUpload={fileUpload}
            loading={loading}
          />
          <DisablilityListingCard
            step={7}
            loading={loading}
            moduleData={cardMessages["Primary Caregivers"]}
            dataList={
              tableData && tableData.primaryCaregiverData
                ? tableData.primaryCaregiverData
                : []
            }
          />
          <DisabilityDocumentDisplayCard
            step={9}
            moduleData={cardMessages["Home Modifications"]}
            documents={
              tableData &&
              tableData.uploadDocumentHomeModificationsData &&
              tableData.uploadDocumentHomeModificationsData
            }
            fileUpload={fileUpload}
            loading={loading}
          />
        </div>
        <div className="mainUpperContainer">
          <DisabilityDocumentDisplayCard
            step={2}
            documents={
              tableData &&
              tableData.uploadDocumentMedicalHistoryData &&
              tableData.uploadDocumentMedicalHistoryData
            }
            moduleData={cardMessages["Medical History"]}
            fileUpload={fileUpload}
            loading={loading}
          />
          <DisabilityLiabilityCard
            loanAmount={totalLoan}
            monetaryValue={monetaryValue}
            loading={loading}
            Icon={assetInfoIcon}
          />
          <DisablilityListingCard
            step={8}
            loading={loading}
            moduleData={cardMessages["Professional Contacts"]}
            dataList={
              tableData && tableData.professionalContactsData
                ? tableData.professionalContactsData
                : []
            }
          />
          <DisabilityDocumentDisplayCard
            step={10}
            moduleData={cardMessages["Equipment Needs"]}
            documents={
              tableData &&
              tableData.adaptiveTechnologyData &&
              tableData.adaptiveTechnologyData
            }
            fileUpload={fileUpload}
            loading={loading}
          />
        </div>
        <div className="mainUpperContainer">
          <div className="DisabilityBudgetCardMain">
            <BudgetExpanse
              data={budgets && budgets}
              loading={loading}
              getAllBudgets={getBudgets}
            />
          </div>
          <DisabilityLegalDocumentCard
            step={6}
            moduleData={cardMessages["Legal Documents"]}
            loading={loading}
          />
          <DisabilityDocumentDisplayCard
            step={11}
            moduleData={cardMessages["Daily Living Preferences"]}
            documents={
              tableData &&
              tableData.uploadDocumentDailyLivingPreferenceData &&
              tableData.uploadDocumentDailyLivingPreferenceData
            }
            fileUpload={fileUpload}
            loading={loading}
          />
        </div>
        <div className="mainUpperContainer">
          <div className="DisabilityInsuarceCardMain">
            <DisabilityInsuranceCard
              dataList={insuranceData}
              step={3}
              moduleData={cardMessages["Insurance Coverage"]}
              loading={loading}
            />
          </div>
          <DisabilityDocumentDisplayCard
            step={12}
            documents={
              tableData &&
              tableData.uploadDocumentCarePlanData &&
              tableData.uploadDocumentCarePlanData
            }
            moduleData={cardMessages["Treatment Preferences"]}
            fileUpload={fileUpload}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};
